// Update collection card price/compare-at display when Swatch King selects a variant.
// Swatch King fires vsk:variant:changed on the .grid-item element with full variant data.
// Our [data-swatch-price] wrapper (in list.product-card.liquid) is the update target.
document.addEventListener('vsk:variant:changed', (event) => {
  const card = event.target.closest('.grid-item')
  if (!card) return

  const priceDisplay = card.querySelector('[data-swatch-price]')
  if (!priceDisplay) return

  const priceStack = priceDisplay.querySelector('layout-stack')
  if (!priceStack) return

  let variantInfo
  try {
    variantInfo = JSON.parse(event.detail.variantInformation)
  } catch (e) {
    return
  }

  const priceDollars = parseFloat(variantInfo.price?.amount)
  const compareAtDollars = variantInfo.compareAtPrice ? parseFloat(variantInfo.compareAtPrice.amount) : 0
  if (isNaN(priceDollars)) return

  const onSale = compareAtDollars > 0 && compareAtDollars > priceDollars
  const superscript = priceDisplay.dataset.superscript === 'true'
  const saveEnabled = priceDisplay.hasAttribute('data-save-enabled')
  const saveType = priceDisplay.dataset.saveType || 'dollar'

  const fmtMoney = (dollars) => {
    const formatted = '$' + dollars.toFixed(2)
    if (superscript) {
      const parts = formatted.split('.')
      return `<span>${parts[0]}</span><sup>${parts[1]}</sup>`
    }
    return formatted
  }

  const fmtSavings = (dollars) => {
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2))
  }

  const superscriptClass = superscript ? ' element-text--price-superscript' : ''
  const priceClass = `element-text element-price element-text--heading-xs${superscriptClass}`

  // Re-append currency code label stripped by innerHTML replace (matches Liquid: if cart.currency.iso_code == "NZD")
  const currency = priceDisplay.dataset.currency
  const currencyLabel = (currency && currency !== 'AUD') ? `<span class="price-currency-code">${currency}</span>` : ''

  let html = `<span class="${priceClass}">${fmtMoney(priceDollars)}</span>${currencyLabel}`

  if (onSale) {
    html += `<span class="${priceClass} element-text--line-through">${fmtMoney(compareAtDollars)}</span>`

    if (saveEnabled) {
      let savedText
      if (saveType === 'dollar') {
        savedText = 'Save ' + fmtSavings(compareAtDollars - priceDollars)
      } else {
        savedText = 'Save ' + Math.round(((compareAtDollars - priceDollars) * 100.0) / compareAtDollars) + '%'
      }
      html += `<span class="element-text element-text--body-sm" style="color: var(--color-text-savings);">${savedText}</span>`
    }
  }

  priceStack.innerHTML = html
})
